import React from 'react';
import { connect } from 'react-redux';

import ButtonLink from 'components/ButtonLink';

import { updateQueryString } from 'services/router/actions';

interface OwnProps {
    id: number;
}

interface DispatchProps {
    updateQueryString: typeof updateQueryString;
}

export interface Props extends OwnProps, DispatchProps {}

export class TimesheetSubmissionsRevertLinkComponent extends React.PureComponent<Props> {
    public handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
        event.stopPropagation();
        const { id, updateQueryString: updateQuery } = this.props;

        updateQuery({
            selectedPayrollExportId: id,
            timesheetSubmissionsRevertModal: true
        });
    };

    public render(): JSX.Element {
        return <ButtonLink onClick={this.handleClick}>Revert</ButtonLink>;
    }
}

export default connect(null, {
    updateQueryString
})(TimesheetSubmissionsRevertLinkComponent);
